import { render, staticRenderFns } from "./HomePazienti.vue?vue&type=template&id=14d5d1a3&"
import script from "./HomePazienti.vue?vue&type=script&lang=js&"
export * from "./HomePazienti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports